﻿class ServerError extends Error {
    constructor(exception) {

        let errorsInResponse = [];

        if (exception.response && exception.response.status === 400)
            errorsInResponse = ServerError.collectCustomErrorsFromResponse(exception.response);

        super(errorsInResponse.length ? errorsInResponse[0] : exception.message);

        this.customErrors = errorsInResponse;

        if (Error.captureStackTrace)
            Error.captureStackTrace(this, ServerError);
        else
            this.toString = () => { return this.name + ': ' + this.message; };
    }

    static collectCustomErrorsFromResponse(response) {

        if (!response.data)
            return [];

        if (!response.data.message && !response.data.inner_exception_message)
            return [];

        let responseData = response.data;

        let error = responseData.inner_exception_message ? responseData.inner_exception_message : responseData.message;

        return error instanceof Array ? error : [error];
    }
}

export default ServerError;